const Roles = [
  { value: "authenticated", label: "Bénéficiaire" },
  { value: "gestionnaire", label: "Gestionnaire" },
  { value: "consultation", label: "Consultation" },
  { value: "administrateur", label: "Administrateur" },
  { value: "partenaire", label: "Partenaire" },
];

export default Roles;
